import React from 'react';
import { Form as FinalForm } from 'react-final-form';

import { FieldTextInput, Form } from '../../../components';

import { required } from '../../../util/validators';

import css from './EndorseModal.module.css';

const EndorseModal = ({ handleSubmit, intl, closeModalHandler }) => {
  return (
    <div>
      <h2 className={css.inviteHeading}>
        {intl.formatMessage({ id: 'ProfilePage.endorseModalTitle' })}
      </h2>
      <FinalForm
        onSubmit={handleSubmit}
        render={formRenderProps => {
          const { handleSubmit, formId = 'SearchTribePage', values, errors } = formRenderProps;
          return (
            <Form className={css.tribeForm} onSubmit={handleSubmit}>
              <FieldTextInput
                id={`${formId}yourEndorsment`}
                name="yourEndorsment"
                type="textarea"
                className={css.inputBox}
                label={intl.formatMessage({ id: 'SearchTribePage.yourEndorsment' })}
                placeholder={intl.formatMessage({
                  id: 'SearchTribePage.yourEndorsmentPlaceholder',
                })}
                validate={required(
                  intl.formatMessage({
                    id: 'SearchTribePage.endorsementRequired',
                    defaultMessage: 'Endorsement text is required',
                  })
                )}
              />
              <div className={css.bottomButton}>
                <button onClick={closeModalHandler} type="button" className={css.borderButton}>
                  {intl.formatMessage({ id: 'ProfilePage.endorseModalCancel' })}
                </button>
                <button
                  type="submit"
                  className={css.submitButton}
                  disabled={!!errors.yourEndorsment || !values.yourEndorsment}
                >
                  {intl.formatMessage({ id: 'ProfilePage.endorseModalSubmit' })}
                </button>
              </div>
            </Form>
          );
        }}
      />
    </div>
  );
};

export default EndorseModal;
